import React, { createContext, useContext, ReactNode } from "react";
import { useTranslation } from 'react-i18next';
import '../i18n'; // Import the i18n configuration

type Language = "en" | "th";

interface LanguageContextProps {
  language: Language;
  switchLanguage: (lang: Language) => void;
  t: ReturnType<typeof useTranslation>['t'];
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { t, i18n } = useTranslation();

  const switchLanguage = (lang: Language) => {
    i18n.changeLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ 
      language: i18n.language as Language, 
      switchLanguage,
      t
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextProps => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
